import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import Button from "../../../Common/Components/Button";
import xiqLogo from "../../../../assets/img/Workbench_Logo.svg";
import lowerBg from "../../../../assets/img/BG.svg";
import LaunchIntro from "./LaunchIntro";

// const windowHeight = window.innerHeight - 200;
const fadeOut = keyframes`
from {  }
to   { opacity:0; }
`;

const circleDown = keyframes`
0% {
  height: 90vh;
  width: 90vh;
  border-radius:50%;
}
100% {
    border-radius:50%;
    height: 0px;
    width: 0px;
 }
`;

const circleBottomRight = keyframes`
to {
   transform: scale(0.5) translate(80vw, 70vh);
}
`;

const scaleDown = keyframes`
from { }
to   {  transform: scale(0.5) translate(-65vw, -60vh ); }
`;
// 6
// transform: scale(0.5) translate(-${left}px, -${top}px );

// ${circleBottomRight} 1s ease-in-out 30s forwards;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  .wrapper-animation {
  }
  .onBoarding {
    .fourth-intro {
      .welcome-roy-icon {
        .animation-wrapper {
          animation: ${circleBottomRight} 1s ease-in-out 14s forwards;
        }
      }
    }
  }
  .wrapper-animation-two {
    animation: ${circleDown} 0.5s ease-in-out 34s forwards;
  }
  .wrapper-class {
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    box-sizing: border-box;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    .container-fluid {
      padding: 0;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      .fade-out {
        animation-name: ${fadeOut};
        animation-delay: 1s;
        animation-duration: 1.5s;
        animation-iteration-count: 1;
        animation-direction: forwards;
        animation-fill-mode: forwards;
      }
    }
    .welcome-text {
      h4.welcome-to {
        font-size: 34px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 24px;
        }
      }
      #workbench-logo-id {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 475px;
        }
      }
      .welcome-roy-icon {
        span {
          // height: 250px;
          // width: 250px;
          // padding: 1em;
          // display: flex;
          // border-radius: 50%;
          // background-color: #fff;
        }
      }
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2;
      .workbench-logo {
        animation: ${scaleDown} 3s 0.5s forwards;
      }
      .roy-dp {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 140px;
        }
      }
      .welcome-roy-icon {
        margin: 3em;
        /* svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
            width: 240px; 
          }*/
        }
      }
      .heading {
        h4 {
          color: rgb(66, 75, 80);
          font-family: roboto_slabregular;
          font-weight: 400;
          font-size: 60px;
          line-height: 60px;
          letter-spacing: -1.5px;
          margin-bottom: 0px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 42px;
            line-height: 42px;
          }
        }
      }
    }
    .get-started {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      background-image: url(${lowerBg});
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
`;

const Welcome: React.FC = (props) => {
  const [showWelcome, setShowWelcome] = useState(false);

  const startAnimation = (e: any) => {
    e.preventDefault();
    setAnimationPlay(true);
    setTimeout(() => {
      setShowWelcome(true);
    }, 3000);
  };
  const [animationPlay, setAnimationPlay] = useState(false);
  //  const imgRef = useRef(null);
  useEffect(() => {
    // console.log("re rendering the welcome components");
    // const imgLogo = document.querySelector("#workbench-logo-id");
    // if(imgLogo != null){
    // var rect = imgLogo.getBoundingClientRect();
    // let top = rect.top + document.body.scrollTop;
    // let left = rect.left + document.body.scrollLeft;
    //  setTop(rect.top + document.body.scrollTop)
    //  setLeft(rect.left + document.body.scrollLeft)
    //}
  }, []);

  return (
    <>
      <Wrapper>
        <div className={`wrapper-class ${animationPlay ? "wrapper-animation wrapper-animation-two" : ""}`}>
          <div className="container-fluid">
            <div className="welcome-text">
              <h4 className={`${animationPlay ? "fade-out" : ""} welcome-to`}>Welcome to</h4>
              <img
                id="workbench-logo-id"
                className={` ${animationPlay ? "workbench-logo" : ""}`}
                src={xiqLogo}
                alt="xiq welcome"
              />
              {showWelcome && (
                <div
                  style={{
                    position: "absolute",
                    height: "100vh",
                    width: "100%",
                    display: "flex",
                    top: 0,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LaunchIntro />
                </div>
              )}
            </div>
            <div className="get-started">
              <a
                className={`${animationPlay ? "fade-out" : ""}`}
                onClick={(e) => startAnimation(e)}
                href="javascript: void(0);"
              >
                <Button value="Ok, let's get started!" />
              </a>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default React.memo(Welcome);

/* @keyframes duration | easing-function | delay |
iteration-count | direction | fill-mode | play-state | name */

// const AnimationWrapper = styled.div`
// display: flex;
// .welcome-text{
//   animation-name: ${fadeOut};
//   animation-delay: 4s;
//   animation-duration: 1.5s;
//   animation-iteration-count:1;
//   animation-fill-mode: forwards;
//   animation-timing-function: ease-all;
// }`;
